import { useState } from "react";
import { Button } from "@mui/material";
import { useAppSelector } from "redux/hooks";
import CollectUsersTable from "./components/CollectUsersTable";
import { selectCollectUsersSorted } from "redux/slices/client";
import CollectInvite from "./CollectInvite";
import { useNavigate } from "react-router";
import { AppRoutes } from "AppRoutes";

function CollectUsers() {
  const [inviteDialogOpen, setInviteDialogOpen] = useState(false);
  const users = useAppSelector(selectCollectUsersSorted);
  const navigate = useNavigate();
  return (
    <div className="flex flex-col h-full">
      <div className="flex justify-between items-center">
        <p className="font-bold text-3xl">Collect Users</p>

        <Button variant="contained" onClick={() => navigate(AppRoutes.usersAppInviteBuilder("collect"))}>
          Invite Users
        </Button>
      </div>
      <CollectUsersTable users={users} />
      {inviteDialogOpen && (
        <CollectInvite
          open={inviteDialogOpen}
          onClose={() => {
            setInviteDialogOpen(false);
          }}
        />
      )}
    </div>
  );
}

export default CollectUsers;
